import { FC, useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { PremiumPrice } from 'src/api/internal/schema';
import { Button } from 'src/components';
import { useViewItemListEvent } from '../hooks/useViewItemListEvent';
import { PricesList } from '../PricesList';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'ea_plans_upgrade' },
  subscribe: { id: 'onboarding_upsell_subscribe_CTA' },
});

export const PricesSection: FC<{
  prices: PremiumPrice[];
  selectedPrice: PremiumPrice | null;
  setSelectedPrice: (price: PremiumPrice) => void;
  onSubscribe: () => void;
  secondaryAction?: {
    text: string;
    onClick: () => void;
  };
}> = ({ prices, selectedPrice, setSelectedPrice, onSubscribe, secondaryAction }) => {
  const intl = useIntl();

  const [displayedPrices, setDisplayedPrices] = useState<PremiumPrice[]>([]);
  const viewItemListEvent = useViewItemListEvent(displayedPrices);

  useEffect(() => {
    if (viewItemListEvent) {
      window.dataLayer.push(viewItemListEvent);
    }
  }, [viewItemListEvent]);

  return (
    <S.SectionWrapper>
      <S.SectionTitle>{intl.formatMessage(msgs.title)}</S.SectionTitle>

      <PricesList
        prices={prices}
        selectedPrice={selectedPrice}
        setSelectedPrice={setSelectedPrice}
        onDisplay={setDisplayedPrices}
      />

      <S.Actions>
        <Button
          data-testid="subscribe"
          buttonType="primary"
          buttonSize="medium"
          wide
          onClick={() => onSubscribe()}
        >
          {intl.formatMessage(msgs.subscribe)}
        </Button>

        {secondaryAction && (
          <Button
            data-testid="skip-upsell-page"
            buttonType="secondary"
            buttonSize="medium"
            wide
            onClick={secondaryAction.onClick}
          >
            {secondaryAction.text}
          </Button>
        )}
      </S.Actions>
    </S.SectionWrapper>
  );
};
